import { render, staticRenderFns } from "./BrandFilter.vue?vue&type=template&id=53d05905&scoped=true&"
import script from "./BrandFilter.vue?vue&type=script&lang=js&"
export * from "./BrandFilter.vue?vue&type=script&lang=js&"
import style0 from "./BrandFilter.vue?vue&type=style&index=0&id=53d05905&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d05905",
  null
  
)

export default component.exports